import {
  HUMAN_STAFF_LIST_SEARCH,
  HUMAN_STAFF_LIST_SEARCH_FAILURE,
  HUMAN_STAFF_LIST_SEARCH_SUCCESS,
  HUMAN_STAFF_UPDATE,
  HUMAN_STAFF_UPDATE_FAILURE,
  HUMAN_STAFF_UPDATE_SUCCESS
} from './mutation-types'

export default {
  state: {
    humanStaffs: []
  },
  getters: {
    humanStaffs: state => {
      return state.humanStaffs
    }
  },
  actions: {
    [HUMAN_STAFF_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/human_staffs'
      var callback = () => {}
      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', { url: url, data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(HUMAN_STAFF_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(HUMAN_STAFF_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [HUMAN_STAFF_UPDATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', { url: '/master/human_staffs/update', data: data })
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(HUMAN_STAFF_UPDATE_FAILURE, res.data)
            } else {
              commit(HUMAN_STAFF_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [HUMAN_STAFF_LIST_SEARCH_FAILURE] (state, params) {
      console.log('HUMAN_STAFF_LIST_SEARCH_FAILURE')
    },
    [HUMAN_STAFF_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('HUMAN_STAFF_LIST_SEARCH_SUCCESS')
      var data = params.data
      state.humanStaffs = data.data
      if (params.callback) {
        params.callback()
      }
    },
    [HUMAN_STAFF_UPDATE_FAILURE] (state, params) {
      console.log('HUMAN_STAFF_UPDATE_FAILURE')
    },
    [HUMAN_STAFF_UPDATE_SUCCESS] (state, params) {
      console.log('HUMAN_STAFF_UPDATE_SUCCESS')
      var data = params.data
      state.humanStaffs = data.data
      if (params.callback) {
        params.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/human-staff-list.js